class BlogPostsList extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.mainViews = [...this.querySelectorAll('[data-main-view]')];
        this.listItems = [...this.querySelectorAll('[data-list-item]')];
        this.toggleButtons = [...this.querySelectorAll('[data-toggle-button]')];
        this.contentElements = [...this.querySelectorAll('[data-content]')];
        this.seizerElement = this.querySelector('[data-seizer]')
        this.initialized = false

        this.init();
    }

    init() {
        this.setSeizerHeight(this.mainViews[0]);

        this.listItems.forEach(item => {
            const header = item.querySelector('.blog-post-header');
            if (header) {
                header.addEventListener('click', this.onHeaderClick.bind(this));
            }
        });

        this.toggleButtons.forEach(button => {
            button.addEventListener('click', this.onToggleButtonClick.bind(this));
        });
    }
    
    onHeaderClick(e) {
        // 防止事件冒泡到toggle按钮
        if (e.target.closest('[data-toggle-button]')) {
            return;
        }
        
        const item = e.target.closest('[data-list-item]');
        if (!item) return;
        
        const toggleButton = item.querySelector('[data-toggle-button]');
        if (toggleButton) {
            this.toggleContent(toggleButton);
        }
    }
    
    onToggleButtonClick(e) {
        e.stopPropagation();
        const toggleButton = e.target.closest('[data-toggle-button]');
        if (!toggleButton) return;
        
        this.toggleContent(toggleButton);
    }
    
    toggleContent(toggleButton) {
        const expanded = toggleButton.getAttribute('aria-expanded') === 'true';
        toggleButton.setAttribute('aria-expanded', !expanded);
        
        const contentId = toggleButton.getAttribute('aria-controls');
        const content = document.getElementById(contentId);
        
        // Update the arrow icon
        const iconArrow = toggleButton.querySelector('.icon-arrow img');
        if (iconArrow) {
            if (expanded) {
                iconArrow.src = iconArrow.src.replace('arrow-up.svg', 'arrow-down.svg');
            } else {
                iconArrow.src = iconArrow.src.replace('arrow-down.svg', 'arrow-up.svg');
            }
        }
        
        if (content) {
            if (expanded) {
                content.classList.remove('expanded');
            } else {
                content.classList.add('expanded');
            }
        }
    }

    onListItemHover(e) {
        const item = e.target;
        const articleId = item.dataset.articleId ;

        if (!articleId) return 

        const mainArticleView = this.mainViews.find(view => view.dataset.articleId === articleId)

        this.setActiveListItem(item)
        this.setActiveMainView(mainArticleView)
        this.setSeizerHeight(mainArticleView)
        this.scrollToView(mainArticleView)
    }   

    setActiveListItem(activeItem) {
        this.setAndRemoveActiveState('list-item', activeItem);
    }

    setActiveMainView(activeView) {
        this.setAndRemoveActiveState('main-view', activeView);
    }

    setAndRemoveActiveState(type, activeElement) {
        const elements = type === 'list-item' ? this.listItems : this.mainViews;

        elements.forEach(element => {
            element.classList.remove('is-active')
        })

        activeElement.classList.add('is-active')
    }

    setSeizerHeight(activeView) {
        this.seizerElement.style.height = activeView.getBoundingClientRect().height + 'px';

        if (!this.initialized) {
            this.classList.remove('loading');
            this.initialized = true
        }
    }

    scrollToView(activeView) {
        if (window.innerWidth < 1024) {
            const topSpace = activeView.getBoundingClientRect().top;
            const headerHeight = document.querySelector('sticky-header') ? document.querySelector('sticky-header').clientHeight : 0
            window.scrollBy({   
                top: topSpace - 15 - headerHeight,
                behavior: 'smooth'
            })          
        }
    }   
}

window.addEventListener('load', () => {
    customElements.define('blog-posts-list', BlogPostsList)
})